export function ArrowButton() {
  return (
    <svg viewBox="0 0 24 24" fill="none" data-arrow>
      <path d="M10.414 12L15 16.586A1 1 0 0113.586 18l-6-6 6-6A1 1 0 1115 7.414L10.414 12z" fill="currentColor"></path>
    </svg>
  );
}